export default "__VITE_ASSET__8c7086b8__"